/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const DownloadEditorFilesEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('DOWNLOAD_EDITOR_FILES_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class DownloadEditorFilesEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DownloadEditorFilesEnabledSettingParser.decode(input).map(res => new DownloadEditorFilesEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return DownloadEditorFilesEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DownloadEditorFilesEnabledSettingParser.encode(data);
    }
    static schema() {
        return DownloadEditorFilesEnabledSettingParser.schema();
    }
}
